import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { Option } from '@components/combobox/combobox.component'
import { ButtonComponent } from '@components/button/button.component'
import { ProgressStep } from 'app/interfaces/progress-step.interface'
import { ProgressBarComponent } from '@components/progress-bar/progress-bar.component'
import { DateFilterComponent } from '@components/date-filter/date-filter.component'
import { InputComponent } from '@components/input/input.component'
import { ApiService, UserInfo } from 'app/services/api.service'
import { LoadingComponent } from '@components/loading/loading.component'
import { ColorComponent } from '@components/color/color.component'
import { RadioComponent } from '../../components/radio/radio.component'
import { AlertComponent } from '../../components/alert/alert.component'
import { ActivatedRoute, Router } from '@angular/router'
import { SearchInputComponent } from '@components/search-input/search-input.component'
import { KitchenColor } from '../../interfaces/kitchen-color'
import { SelectValue } from '../../interfaces/select-value.interface'
import { SelectComponent } from '@components/select/select.component'
import { LinkComponent } from '@components/link/link.component'
import { ConfirmModalComponent } from '@components/confirm-modal/confirm-modal.component'
import { PlatformService, PlatformName } from 'app/services/platform.service'
import { environment } from '../../../environments/environment'
import { forkJoin, map } from 'rxjs'

@Component({
    selector: 'app-register-display-form',
    standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ButtonComponent,
    ProgressBarComponent,
    DateFilterComponent,
    InputComponent,
    LoadingComponent,
    ColorComponent,
    RadioComponent,
    AlertComponent,
    SearchInputComponent,
    SelectComponent,
    LinkComponent,
    ConfirmModalComponent
  ],
    templateUrl: './register-display-form.component.html',
    styleUrls: ['./register-display-form.component.scss'],
})
export class RegisterDisplayFormComponent implements OnInit, OnDestroy {
    // --- STATE MANAGEMENT ---
    @Input({ required: true }) creating: boolean
    public displayId: string
    public displayToRenewId: string
    showSummary: boolean = false
    public step: number = 1
    public applicationTypeSelected = false
    public applicationColorSelected = false
    public applicationModelSelected = false
    public addingNew = true
    public editingIndex: number | null = null
    public isDragging = false
    public uploadError: string | null = null
    public preferedArrivalDateError: boolean = false
    public installationDateError: boolean = false
    public acceptTerms: boolean = false
    public isSelecting: boolean = false
    //public firstAccessStep2: boolean = true;
    public isReplacement: boolean | null = null
    public isForMe: boolean | null = null
    public availableStock: boolean | null = true
    public displaySFId: string | null = null

    userInfo: UserInfo

    //public brands: string[] = [];
    //public colors: { label: string, value: string }[] = [];
    public collaborators: Option[] = [] // Almacena los colaboradores de la API
    public loadingCollaborators: boolean = true // Estado de carga
    public loadingDisplayInfo: boolean = true
    public displaysByBrand: Option[] = []
    //public teamMembers: any[] = []; // Almacena los miembros del equipo desde la API
    //public loadingTeamMembers: boolean = true; // Estado de carga para team members

    public colors: KitchenColor[] = []
    public loadingColors: boolean = false
    // Relaciona el colorCode de un color visible (base) con el colorCode de su
    // variante JUM/JUMBO oculta, para reutilizarlo al pedir finishes/formats/thicknesses.
    private jumboColorRelations = new Map<string, string>()
    public finishes: any[] = []
    public loadingFinishes: boolean = false
    public formats: any[] = []
    public loadingFormats: boolean = false
    public thicknesses: any[] = []
    public loadingThicknesses: boolean = false
    public addons: any[] = []
    public loadingAddons: boolean = false
    public textures: any[] = []
    public loadingTextures: boolean = false
    public sinkModels: any[] = []
    public loadingSinkModels: boolean = false
    public showerModels: any[] = []
    public loadingShowerModels: boolean = false
    public sinkSubmodels: any[] = []
    public loadingSinkSubmodels: boolean = false
    public sinkBrands: any[] = []
    public loadingSinkBrands: boolean = false
    public sinkFinishes: any[] = []
    public sinkFormats: any[] = []
    public sinkMitreds: any[] = []
    public loadingSinkMitreds: boolean = false
    public fullConfigCTS: any = null

    public loadingSF: boolean = false

    public legalNoticeLink = 'https://forms.cosentino.com/legal-notice/'

    // Modal de error
    public isErrorModalVisible: boolean = false
    public errorModalTitle: string = ''
    public errorModalMessage: string = ''

    // public devSkipToWarranty = false;

    public todayDate: string = this.formatDateMMDDYYYY(new Date())

    countries = [
        { label: 'United States', value: 'United States' },
        { label: 'Spain', value: 'Spain' },
        { label: 'Germany', value: 'Germany' },
        { label: 'France', value: 'France' },
        { label: 'Italy', value: 'Italy' },
        { label: 'Canada', value: 'Canada' },
        { label: 'United Kingdom', value: 'United Kingdom' },
        { label: 'Mexico', value: 'Mexico' },
        { label: 'Brazil', value: 'Brazil' },
        { label: 'Australia', value: 'Australia' },
    ]

    public selectedWarrantyOption: 'activate' | 'instructions' | null = null
    public warrantyFormMode: 'activate' | 'instructions' | null = null

    // --- DATA ---
    public addedApplications: {
        application: string
        model: string
        brand: string
        color: string
        resolvedColorCode: string
        name: string
        thumbImage: string
        size: string
        finish: string
        format: string
        thickness: string
        addon: string
        mitred: string
        texture: string
        requiredSlabs: string
        preferedArrivalDate: string
        preferedArrivalDateDate: Date | null
    }[] = []

    public whichForm = {
        brand: '',
        display: '',
    }

    public addForm = {
        application: '',
        professional: '',
        installationDate: '',
    }

    public installationDateJs: Date | null = null

    public applicationForm = {
        application: '',
        model: '',
        brand: '',
        color: '',
        // colorCode PCM real a enviar (puede diferir de `color` si el finish/format/thickness elegido viene de la variante jumbo oculta).
        resolvedColorCode: '',
        name: '',
        thumbImage: '',
        size: '',
        finish: '',
        format: '',
        thickness: '',
        addon: '',
        texture: '',
        mitred: '',
        requiredSlabs: '',
        preferedArrivalDate: '',
        preferedArrivalDateDate: null as Date | null,
    }

    public sinkForm = {
        model: '',
        brand: '',
        color: '',
        finish: '',
        format: '',
        mitred: '',
        width: '',
        length: ''
    }

    public showerForm = {
        model: '',
        brand: '',
        color: '',
        finish: '',
        format: '',
        mitred: '',
        width: '',
        length: ''
    }

    public uploadedSketches: {
        name: string
        type: string
        size: number
        file: File
    }[] = []

    // --- UI CONFIG ---
    public progressSteps: ProgressStep[] = [
        { title: this.translate.instant('my_displays.progress_create_step_1') },
        { title: this.translate.instant('my_displays.progress_create_step_2') },
        { title: this.translate.instant('my_displays.progress_create_step_3') },
    ]
    private applicationsWithUnits = ['indoor_kitchen', 'washbasin']
    private readonly MAX_FILE_SIZE = 4 * 1024 * 1024
    private readonly MIN_DPI = 96
    private readonly ALLOWED_FILE_TYPES = ['image/png', 'image/jpeg', 'application/pdf']

    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>
    @ViewChild('sizeInputNative') sizeInputNative!: ElementRef<HTMLInputElement>

    // Variable para mantener el valor visual del input size (con coma o punto como lo escribió el usuario)
    public sizeDisplayValue: string = ''

    // SELECT OPTIONS
    sinkOptions: SelectValue[] = []
    selectedSink: SelectValue | null = null

    // Generic select options/state (avoid calling functions from template)
    whichBrandOptions: SelectValue[] = [
        { value: 'SILESTONE', label: 'my_displays.silestone', id: 'SILESTONE' },
        { value: 'DECKTON', label: 'my_displays.dekton', id: 'DECKTON' },
        { value: 'SENSA', label: 'my_displays.sensa', id: 'SENSA' },
    ]
    selectedWhichBrand: SelectValue | null = null

    whichDisplayOptions: SelectValue[] = []
    selectedWhichDisplay: SelectValue | null = null

    applicationOptions: SelectValue[] = [
        { value: 'kitchen', label: 'my_displays.application_kitchen', id: 'kitchen' },
        { value: 'bath', label: 'my_displays.application_bath', id: 'bath' },
        { value: 'other_spaces', label: 'my_displays.application_other_spaces', id: 'other_spaces' },
    ]
    selectedApplicationOption: SelectValue | null = null

    professionalOptions: SelectValue[] = []
    selectedProfessionalOption: SelectValue | null = null

    // Application details options
    finishOptions: SelectValue[] = []
    selectedFinishOption: SelectValue | null = null

    formatOptions: SelectValue[] = []
    selectedFormatOption: SelectValue | null = null

    thicknessOptions: SelectValue[] = []
    selectedThicknessOption: SelectValue | null = null

    addonOptions: SelectValue[] = []
    selectedAddonOption: SelectValue | null = null

    textureOptions: SelectValue[] = []
    selectedTextureOption: SelectValue | null = null

    // Sink flow options
    sinkBasinOptions: SelectValue[] = []
    selectedSinkBasinOption: SelectValue | null = null

    sinkBrandOptions: SelectValue[] = []
    selectedSinkBrandOption: SelectValue | null = null

    sinkColorOptions: SelectValue[] = []
    selectedSinkColorOption: SelectValue | null = null

    sinkFinishOptions: SelectValue[] = []
    selectedSinkFinishOption: SelectValue | null = null

    sinkFormatOptions: SelectValue[] = []
    selectedSinkFormatOption: SelectValue | null = null

    // --- LIFECYCLE HOOKS ---
    ngOnInit(): void {
        if (!environment.webComponent) {
            this.previousPlatform = this.platformService.getPlatform()
            this.currentPlatform = 'DISPLAYS'
            this.platformService.setContextualPlatform('DISPLAYS')
        }

        this.api.userInfo.subscribe((userInfo) => (this.userInfo = userInfo))
        //Reutilizamos la variable collaborators para almacenar las tiendas asociadas en caso de ser Fabricator o marmolistas asociados si se trata de una tienda
        if (this.userInfo.accountType === 'RETAIL' || this.userInfo.accountType === 'DESIGNER') {
            this.api.myDisplays__relatedAccounts(true).subscribe({
                next: (collaborators) => {
                    this.collaborators = this.transformCollaborators(collaborators)
                    this.professionalOptions = this.mapToSelectValues(this.collaborators)
                    this.selectedProfessionalOption = this.toSelectValue(this.professionalOptions, this.addForm.professional)
                    this.loadingCollaborators = false
                    this.loadDisplayInfo()
                    this.cdr.detectChanges()
                },
                error: (error) => {
                    console.error('Error al obtener colaboradores:', error)
                    this.loadingCollaborators = false
                    this.collaborators = [{ value: 'error', label: 'Error al cargar' }]
                    this.loadDisplayInfo()
                    this.cdr.detectChanges()
                },
            })
        } else if (this.userInfo.accountType === 'FABRICATOR' || this.userInfo.accountType === 'DISTRIBUTOR') {
            this.api.myDisplays__relatedAccounts(false).subscribe({
                next: (stores) => {
                    this.collaborators = this.transformStores(stores)
                    this.professionalOptions = this.mapToSelectValues(this.collaborators)
                    this.selectedProfessionalOption = this.toSelectValue(this.professionalOptions, this.addForm.professional)
                    this.loadingCollaborators = false
                    this.loadDisplayInfo()
                    this.cdr.detectChanges()
                },
                error: (error) => {
                    console.error('Error al obtener colaboradores:', error)
                    this.loadingCollaborators = false
                    this.collaborators = [{ value: 'error', label: 'Error al cargar' }]
                    this.loadDisplayInfo()
                    this.cdr.detectChanges()
                },
            })
        }
        console.log('User market for date format: ', this.userInfo.market); 
    }

    private loadDisplayInfo() {
        this.route.queryParams.subscribe((params) => {
            const displayToRenew = params['displayToRenew']
            if (displayToRenew) {
              this.displayToRenewId = displayToRenew
              this.setIsReplacement(true)
              this.step = 1
            }
            const displayId = params['displayId']
            if (displayId) {
                this.displayId = displayId
                this.displaySFId = displayId
                this.api.myDisplays__getDisplay(displayId).subscribe({
                    next: (display: any) => {
                        console.log('Display found:', display)
                        this.step = 2
                        this.addingNew = false
                        const displayItems = Array.isArray(display) ? display : display?.displayItems || []
                        this.addedApplications = displayItems.map((item: any) => ({
                            // PCM/Salesforce devuelve el application en mayúsculas con espacios; las claves i18n son snake_case en minúsculas.
                            application: (item.application || '').toLowerCase().trim().replace(/\s+/g, '_'),
                            brand: item.brand,
                            color: item.productCode,
                            name: item.name,
                            thumbImage: item.thumbImage,
                            size: item.size,
                            finish: item.finish,
                            format: item.format,
                            thickness: item.thickness,
                            addon: item.addon,
                            requiredSlabs: item.requiredSlabs,
                            preferedArrivalDate: item.preferedArrivalDate,
                        }))
                        this.addForm = {
                            application: (display.environment || '').toLowerCase(),
                            professional: (display.fabricatorId || ''),
                            installationDate: (display.deliveredDate || '').toLowerCase(),
                        }

                        this.installationDateJs = this.addForm.installationDate ? new Date(this.addForm.installationDate) : null

                        this.selectedApplicationOption = this.applicationOptions.find((app) => app.value.toLowerCase() === this.addForm.application?.toLowerCase()) || null
                        this.selectedProfessionalOption = this.professionalOptions.find((professional) => professional.value === this.addForm.professional) || null

                        this.loadingDisplayInfo = false
                    },
                    error: (err) => {
                        this.loadingDisplayInfo = false
                        console.error('Error al obtener info display:', err)
                    },
                })
            } else {
                this.loadingDisplayInfo = false
            }
        })
    }

    public currentPlatform: PlatformName
    private previousPlatform: PlatformName | null = null

    constructor(
        private api: ApiService,
        private cdr: ChangeDetectorRef,
        private route: ActivatedRoute,
        private translate: TranslateService,
        private router: Router,
        private platformService: PlatformService,
    ) {
        this.currentPlatform = this.platformService.getPlatform()
    }

    private translations(){
        this.translate.get([
            'my_displays.progress_create_step_1',
            'my_displays.progress_create_step_2',
            'my_displays.progress_create_step_3',

            'my_displays.silestone',
            'my_displays.dekton',
            'my_displays.sensa',

            'my_displays.application_kitchen',
            'my_displays.application_bath',
            'my_displays.application_other_spaces',

            'my_displays.invalid_file_type',
            'my_displays.file_too_large'
        ])
    }

    public setIsReplacement(isReplacement: boolean): void {
        this.isReplacement = isReplacement
    }

    public setIsForMe(isForMe: boolean): void {
        this.isForMe = isForMe
        if (isForMe) {
            this.addForm.professional = this.userInfo.salesforceAccountId ?? ''
        }
    }

    public setAvailableStock(available: boolean): void {
        this.availableStock = available
    }

    private transformCollaborators(collaborators: any[]): Option[] {
        return collaborators
            .map((collaborator) => {
                let value = collaborator.id || collaborator.value || collaborator.toString()
                let label = collaborator.name || collaborator.label || collaborator.toString() || value

                if (typeof collaborator === 'object' && collaborator !== null) {
                    value = collaborator.id || collaborator.value || Object.keys(collaborator)[0] || value
                    label = collaborator.name || collaborator.label || collaborator[value] || label
                }

                return { value: value.toString(), label: label.toString() }
            })
            .filter((option) => option.value && option.label)
    }

    private transformStores(stores: any[]): Option[] {
        return stores
            .map((store) => {
                let value = store.id || store.value || store.toString()
                let label = store.name || store.label || store.toString() || value

                return { value: value.toString(), label: label.toString() }
            })
            .filter((option) => option.value && option.label)
    }

    public getProfessionalOptions(): Option[] {
        return this.loadingCollaborators ? [{ value: 'loading', label: 'Cargando...' }] : this.collaborators
    }

    public canContinue(): boolean {
        if (this.step === 0) {
            if (this.userInfo.accountType === 'RETAIL' || this.userInfo.accountType === 'DESIGNER') {
                if (this.isReplacement === false) {
                    return true
                } else {
                    return !!this.whichForm.brand && !!this.whichForm.display
                }
            } else if (this.userInfo.accountType === 'FABRICATOR' || this.userInfo.accountType === 'DISTRIBUTOR') {
                return this.isReplacement != null
            }
        } else if (this.step === 1) {
            if (this.userInfo.accountType === 'FABRICATOR' || this.userInfo.accountType === 'DISTRIBUTOR') {
                if (this.isForMe) return !!this.addForm.application
                else return !!this.addForm.application && !!this.addForm.professional
            }
            const isFormValid = this.addForm.application?.trim() && this.addForm.professional?.trim() && this.addForm.installationDate?.trim() && !this.installationDateError
            if (!isFormValid) {
                return false
            }
        } else if (this.step === 2 && !this.applicationTypeSelected && this.addingNew) {
            return !!this.applicationForm.application
        } else if(this.step === 2 && this.applicationTypeSelected && this.addingNew && (this.applicationForm.application === 'bath_showertray' || this.applicationForm.application === 'bath_sink')) {
          if (this.userInfo.accountType === 'FABRICATOR' || this.userInfo.accountType === 'DISTRIBUTOR') {
            return (
              this.sinkForm.brand !== '' && this.sinkForm.color !== '' && this.sinkForm.finish !== '' && this.sinkForm.length !== '' && this.sinkForm.width !== '' &&
              this.availableStock === true ||
              (this.availableStock === false && this.slabsSizeValid() && !!this.applicationForm.preferedArrivalDate && !this.preferedArrivalDateError)
            )
          } else if (this.userInfo.accountType === 'RETAIL' || this.userInfo.accountType === 'DESIGNER') {
            return (
              this.sinkForm.brand !== '' && this.sinkForm.color !== '' && this.sinkForm.finish !== '' && this.sinkForm.length !== '' && this.sinkForm.width !== ''
            )
          }
        } else if (this.step === 2 && this.applicationTypeSelected && !this.applicationColorSelected && this.addingNew && this.applicationForm.application === 'sink') {
            return this.sinkForm.format !== '' && this.sinkForm.finish !== '' && this.sinkForm.color !== '' && this.sinkForm.brand !== '' && this.sinkForm.model !== ''
        } else if (this.step === 2 && this.applicationTypeSelected && !this.applicationColorSelected && this.addingNew) {
            return !!this.applicationForm.color
        } else if (this.step === 2 && (this.userInfo.accountType === 'RETAIL' || this.userInfo.accountType === 'DESIGNER') && this.applicationTypeSelected && this.applicationColorSelected && this.addingNew) {
            return (
                (this.applicationForm.application === 'flooring' || !!this.applicationForm.size) &&
                !!this.applicationForm.finish &&
                !!this.applicationForm.format &&
                !!this.applicationForm.thickness
            )
        } else if (this.step === 2 && (this.userInfo.accountType === 'FABRICATOR' || this.userInfo.accountType === 'DISTRIBUTOR') && this.applicationTypeSelected && this.applicationColorSelected && this.addingNew) {
            return (
                (this.applicationForm.application === 'flooring' || !!this.applicationForm.size) &&
                !!this.applicationForm.finish &&
                !!this.applicationForm.format &&
                !!this.applicationForm.thickness &&
                !!this.applicationForm.requiredSlabs &&
                this.slabsSizeValid() &&
                (this.availableStock === true ||
                    (this.availableStock === false && this.slabsSizeValid() && !!this.applicationForm.preferedArrivalDate && !this.preferedArrivalDateError))
            )
        } else if (this.step === 2 && !this.addingNew) {
            return this.addedApplications.length > 0
        } else if (this.step === 3) {
            return this.uploadedSketches.length > 0 && this.acceptTerms
        }
        return true
    }

    public onContinue(): void {
        if (!this.canContinue()) return

        if (this.step === 0) {
            this.step = 1
            this.removeOldDisplay()
        } else if (this.step === 1) {
            this.step = 2
            return
        } else if (this.step === 2) {
            if (!this.applicationTypeSelected && this.addingNew) {
                this.applicationTypeSelected = true
                if (this.applicationForm.application === 'sink') {
                    this.loadSinkModels()
                    return
                }
                if (this.applicationForm.application === 'bath_showertray') {
                    //this.loadSinkModels()
                    this.loadModelsCTS()
                    return
                }
                if (this.applicationForm.application === 'bath_sink') {
                    this.loadModelsCTS()
                    return
                }
                this.loadColors()
                return
            } else if (!this.applicationColorSelected && this.addingNew) {
                if (this.applicationForm.application === 'sink' || this.applicationForm.application === 'bath_showertray' || this.applicationForm.application === 'bath_sink') {
                    this.saveOrUpdateApplication()
                } else {
                    this.loadFinishes()
                }
                this.applicationColorSelected = true
                return
            } else if (
                (this.applicationForm.size !== '' || this.applicationForm.finish !== '' || this.applicationForm.format !== '' || this.applicationForm.thickness !== '') &&
                this.addingNew
            ) {
                this.saveOrUpdateApplication()
            } else {
                this.step = 3
              this.getLegalNoticeLink()
            }
            return
        } else if (this.step === 3) {
            this.createDisplay('Incomplete', this.displayToRenewId)
        }
    }

    public goToList(): void {
        this.router.navigate(['/my-displays'])
    }

    public goBack(): void {
        if (this.step === 1) {
            this.step = 0
            this.resetForm()
        } else if (this.step === 2) {
            this.step = 1
            this.addingNew = true
            this.addedApplications = []
            this.resetForm()
        } else if (this.step === 3) {
            this.step = 2
            this.addingNew = false
        } else {
            this.router.navigate(['/my-displays'])
        }
    }

    public saveDraft(): void {
        this.createDisplay('Draft', this.displayToRenewId)
        console.log('Borrador guardado:', {
            addForm: this.addForm,
            addedApplications: this.addedApplications,
            uploadedSketches: this.uploadedSketches,
        })
    }

    public addNewApplication(): void {
        this.resetForm()
        this.addingNew = true
    }

    public cancelAddOrEdit(): void {
        this.addingNew = false
        this.resetForm()
    }

    public deleteApplication(index: number): void {
        this.addedApplications.splice(index, 1)
        if (this.addedApplications.length === 0) {
            this.resetForm()
            this.addingNew = true
        }
    }

    public editApplication(index: number): void {
        this.editingIndex = index
        const appToEdit = this.addedApplications[index]
        this.applicationForm = { ...appToEdit }
        this.addingNew = true
        this.step = 1
    }

    // -v-v- FILE MANAGEMENT -v-v-
    public onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement
        if (input.files && input.files.length > 0) {
            this.handleFiles(input.files)
        } else {
            this.isSelecting = false
        }
        if (this.fileInput) {
            this.fileInput.nativeElement.value = ''
        }
    }

    public onDragOver(event: DragEvent): void {
        event.preventDefault()
        event.stopPropagation()
        this.isDragging = true
    }

    public onDragLeave(): void {
        this.isDragging = false
    }

    public onDrop(event: DragEvent): void {
        event.preventDefault()
        event.stopPropagation()
        this.isDragging = false
        if (event.dataTransfer?.files) {
            this.handleFiles(event.dataTransfer.files)
        }
    }

    private handleFiles(files: FileList): void {
        this.uploadError = null
        Array.from(files).forEach((file) => {
            if (!this.ALLOWED_FILE_TYPES.includes(file.type)) {
                this.uploadError = 'create-claim.documentation.invalid_file_type'
                return
            }
            if (file.size > this.MAX_FILE_SIZE) {
                this.uploadError = 'my_sales.file_too_large'
                return
            }
            this.uploadedSketches.push({
                name: file.name,
                type: file.type,
                size: file.size,
                file: file,
            })
        })
        if (this.fileInput) {
            this.fileInput.nativeElement.value = ''
        }
        this.isSelecting = false
    }

    public deleteSketch(index: number): void {
        this.uploadedSketches.splice(index, 1)
    }

    public downloadSketch(sketch: any): void {
        // Si tienes la URL de la imagen
        if (sketch.url) {
            const link = document.createElement('a')
            link.href = sketch.url
            link.download = sketch.filename || 'imagen.jpg'
            link.click()
        }
        // Si tienes el File object
        else if (sketch.file) {
            const url = URL.createObjectURL(sketch.file)
            const link = document.createElement('a')
            link.href = url
            link.download = sketch.filename || sketch.file.name
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            URL.revokeObjectURL(url) // Limpiar memoria
        }
    }

    public previewSketch(sketch: { name: string; type: string; size: number; file: File }): void {
        const url = URL.createObjectURL(sketch.file)
        window.open(url, '_blank')
    }
    // -^-^- FILE MANAGEMENT -^-^-

    // -v-v- PRIVATE HELPERS -v-v-
    private saveOrUpdateApplication(): void {
        if (this.applicationForm.application === 'shower_tray' || this.applicationForm.application === 'bath_showertray' || this.applicationForm.application === 'sink' || this.applicationForm.application === 'bath_sink') {
          this.applicationForm.model = this.showerForm.model ? this.showerForm.model : this.sinkForm.model
          this.applicationForm.brand = this.showerForm.brand ? this.showerForm.brand : this.sinkForm.brand
          this.applicationForm.color = this.showerForm.color ? this.showerForm.color : this.sinkForm.color
          this.applicationForm.finish = this.showerForm.finish ? this.showerForm.finish : this.sinkForm.finish
          this.applicationForm.format = this.showerForm.format ? this.showerForm.format : (this.showerForm.width ? this.showerForm.width : this.sinkForm.width + 'x' + this.showerForm.length ? this.showerForm.length : this.sinkForm.length)
          this.applicationForm.mitred = this.showerForm.mitred ? this.showerForm.mitred : this.sinkForm.mitred

        }
        if (this.editingIndex !== null) {
            this.addedApplications[this.editingIndex] = { ...this.applicationForm }
        } else {
            this.addedApplications.push({ ...this.applicationForm })
        }
        this.addingNew = false
        this.resetForm()
        this.cdr.detectChanges()
    }

    private resetForm(): void {
        this.editingIndex = null
        this.applicationTypeSelected = false
        this.applicationColorSelected = false
        this.applicationModelSelected = false
        this.selectedSink = null
        this.selectedSinkBrandOption = null
        this.selectedSinkColorOption = null
        this.selectedSinkFinishOption = null
        this.selectedSinkFormatOption = null
        this.applicationForm = {
            application: '',
            model: '',
            brand: '',
            color: '',
            resolvedColorCode: '',
            name: '',
            thumbImage: '',
            size: '',
            finish: '',
            format: '',
            thickness: '',
            addon: '',
            texture: '',
            mitred: '',
            requiredSlabs: '',
            preferedArrivalDate: '',
            preferedArrivalDateDate: null,
        }
        this.showerForm = {
            model: '',
            brand: '',
            color: '',
            finish: '',
            format: '',
            mitred: '',
            width: '',
            length: ''
        }
        this.sinkForm = {
            model: '',
            brand: '',
            color: '',
            finish: '',
            format: '',
            mitred: '',
            width: '',
            length: ''
        }
        this.uploadError = null
    }

    private getTodayDate(): string {
        const today = new Date()
        return today.toISOString().split('T')[0]
    }
    // -^-^- PRIVATE HELPERS -^-^-

    public getWhichBrandOptions(): Option[] {
        return [
            { value: 'SILESTONE', label: 'my_displays.silestone' },
            { value: 'DECKTON', label: 'my_displays.dekton' },
            { value: 'SENSA', label: 'my_displays.sensa' },
        ]
    }

    public selectWhichBrand(value: SelectValue | null): void {
        this.whichForm.brand = value?.value
        this.selectedWhichBrand = value
        this.getDisplaysByBrand(this.whichForm.brand)
    }

    private getDisplaysByBrand(brand: string): void {
        this.api.myDisplays__getDisplayByBrand(brand).subscribe({
            next: (response) => {
                console.log('List displays by brand:', response)
                this.displaysByBrand = response.map((display) => ({
                    value: display.id,
                    label: display.displayItems[0]?.colorCode || display.name + display.application,
                }))
                this.whichDisplayOptions = this.mapToSelectValues(this.displaysByBrand)
                this.selectedWhichDisplay = this.toSelectValue(this.whichDisplayOptions, this.whichForm.display)
            },
            error: (error) => {
                console.error('Error fetching displays by brand:', error)
                this.whichDisplayOptions = []
                this.selectedWhichDisplay = null
            },
        })
    }

    public selectWhichDisplay(value: SelectValue | null): void {
        this.whichForm.display = value?.value
        this.selectedWhichDisplay = value
    }

    private removeOldDisplay(): void {
        // TODO: remove display
    }

    public validateInstallationDate(): void {
        const selectedDate = new Date(this.addForm.installationDate)
        const today = new Date(this.getTodayDate())
        const minInstallationDate = new Date(today)
        minInstallationDate.setDate(today.getDate() + 15)
        this.installationDateError = selectedDate < minInstallationDate
    }

    public validatePreferedArrivalDate(): void {
        const selectedDate = new Date(this.applicationForm.preferedArrivalDate)
        const today = new Date(this.getTodayDate())
        const minInstallationDate = new Date(today)
        minInstallationDate.setDate(today.getDate() + 15)
        this.preferedArrivalDateError = selectedDate < minInstallationDate
    }

    public slabsSizeValid(): boolean {
        //return this.applicationForm.application === 'flooring' || +this.applicationForm.requiredSlabs <= +this.applicationForm.size / 3
        return true
    }

    public isImage(fileType: string): boolean {
        return fileType === 'image/png' || fileType === 'image/jpeg'
    }

    public selectApplication(value: SelectValue | null): void {
        this.addForm.application = value?.value
        this.selectedApplicationOption = value
    }

    public selectProfessional(value: SelectValue | null): void {
        this.addForm.professional = value?.value
        this.selectedProfessionalOption = value
    }

    public selectColor(colorData: any): void {
        this.resetApplicationDetails()
        this.applicationForm.name = colorData.name
        this.applicationForm.color = colorData.colorCode
        this.applicationForm.resolvedColorCode = colorData.colorCode
        this.applicationForm.brand = colorData.brand
        this.applicationForm.thumbImage = colorData.image
        this.cdr.detectChanges()
    }

    public selectFinish(value: SelectValue | null): void {
        this.applicationForm.finish = value?.value
        this.selectedFinishOption = value
        this.applicationForm.resolvedColorCode = this.resolveColorCodeFor(this.finishes, 'finishCode', value?.value)
        this.applicationForm.format = ''
        this.applicationForm.thickness = ''
        this.selectedFormatOption = null
        this.selectedThicknessOption = null
        this.loadFormats()
    }

    public selectFormat(value: SelectValue | null): void {
        this.applicationForm.format = value?.value
        this.selectedFormatOption = value
        this.applicationForm.resolvedColorCode = this.resolveColorCodeFor(this.formats, 'format', value?.value)
        this.applicationForm.thickness = ''
        this.selectedThicknessOption = null
        this.loadThicknesses()
    }

    public selectThickness(value: SelectValue | null): void {
        this.applicationForm.thickness = value?.value
        this.selectedThicknessOption = value
        this.applicationForm.resolvedColorCode = this.resolveColorCodeFor(this.thicknesses, 'thickness', value?.value)
        this.applicationForm.addon = ''
        this.selectedAddonOption = null
        this.loadAddons()
    }

    public selectAddon(value: SelectValue | null): void {
        this.applicationForm.addon = value?.value
        this.selectedAddonOption = value
        this.applicationForm.texture = ''
        this.selectedTextureOption = null
        this.loadTextures()
    }

    public selectTexture(value: SelectValue | null): void {
      this.applicationForm.texture = value?.value
      this.selectedTextureOption = value
    }

    public selectSinkModel(value: SelectValue | null): void {
        this.selectedSink = value
        this.sinkForm.model = value?.value || ''
        this.applicationForm.model = value?.value || ''
        this.sinkForm.brand = ''
        this.applicationForm.brand = ''
        this.sinkForm.color = ''
        this.applicationForm.color = ''
        this.sinkForm.finish = ''
        this.applicationForm.finish = ''
        this.sinkForm.format = ''
        this.applicationForm.format = ''
        this.sinkForm.mitred = ''
        this.applicationForm.mitred = ''
        this.selectedSinkBrandOption = null
        this.selectedSinkColorOption = null
        this.selectedSinkFinishOption = null
        this.selectedSinkFormatOption = null
        if (value) {
            this.loadSinkSubmodels().then(() => {
                this.loadSinkBrands()
            })
        } else {
            this.sinkBrandOptions = []
        }
    }

    public selectSinkBrands(value: SelectValue | null): void {
        this.sinkForm.brand = value?.value
        this.applicationForm.brand = value?.value
        this.selectedSinkBrandOption = value
        this.sinkForm.color = ''
        this.applicationForm.color = ''
        this.sinkForm.finish = ''
        this.applicationForm.finish = ''
        this.sinkForm.format = ''
        this.applicationForm.format = ''
        this.sinkForm.mitred = ''
        this.applicationForm.mitred = ''
        this.selectedSinkColorOption = null
        this.selectedSinkFinishOption = null
        this.selectedSinkFormatOption = null
        if (value) {
            this.loadSinkColors()
        } else {
            this.sinkColorOptions = []
        }
    }

    public selectSinkColor(value: SelectValue | null): void {
        this.sinkForm.color = value?.value
        this.applicationForm.color = value?.value
        this.applicationForm.name = value?.label || ''
        this.selectedSinkColorOption = value
        this.sinkForm.finish = ''
        this.applicationForm.finish = ''
        this.sinkForm.format = ''
        this.applicationForm.format = ''
        this.sinkForm.mitred = ''
        this.applicationForm.mitred = ''
        this.selectedSinkFinishOption = null
        this.selectedSinkFormatOption = null
        this.applicationForm.thumbImage = value?.image || ''
        if (value) {
            this.loadSinkFinishes()
        } else {
            this.sinkFinishOptions = []
        }
    }

    public selectSinkFinish(value: SelectValue | null): void {
        this.sinkForm.finish = value?.value
        this.applicationForm.finish = value?.value
        this.selectedSinkFinishOption = value
        this.sinkForm.format = ''
        this.applicationForm.format = ''
        this.sinkForm.mitred = ''
        this.applicationForm.mitred = ''
        this.selectedSinkFormatOption = null
        if (value) {
            this.loadSinkFormats()
        } else {
            this.sinkFormatOptions = []
        }
    }

    public selectSinkFormat(value: SelectValue | null): void {
        this.sinkForm.format = value?.value
        this.applicationForm.format = value?.value
        this.selectedSinkFormatOption = value
        this.sinkForm.mitred = ''
        this.applicationForm.mitred = ''
    }

    public selectSinkMitred(value: string): void {
        this.sinkForm.mitred = value
        this.applicationForm.mitred = value
    }

    public selectedFullConfigBrands(value: SelectValue | null): void {
        const brandKey = value?.value || '';
        this.sinkForm.brand = brandKey;
        const colors = brandKey ? this.fullConfigCTS.brands[brandKey] : null;
        this.sinkColorOptions = colors ? Object.entries(colors).map(([key, colorData]: [string, any]) => ({
                id: colorData.color,
                value: colorData.color,
                label: colorData.colorName
            })) : [];
    }

    public selectedFullConfigColor(value: SelectValue | null): void {
        const colorKey = value?.value || '';
        this.sinkForm.color = colorKey;
        const finishes = colorKey ? this.fullConfigCTS.brands[this.sinkForm.brand].filter((color: any) => color.color === colorKey)[0].finishes  : null;
        this.sinkFinishOptions = finishes ? Object.entries(finishes).map(([key, finishData]: [string, any]) => ({
                id: finishData.finishId,
                value: finishData.finishId,
                label: finishData.finishName
            })) : [];
    }

    public selectedFullConfigFinish(value: SelectValue | null): void {
        const finishKey = value?.value || '';
        this.sinkForm.finish = finishKey;
    }

    public onWorktopLengthChange(event: Event): void {
        const input = event.target as HTMLInputElement
        this.sinkForm.length = input.value;
    }

    public onWorktopWidthChange(event: Event): void {
        const input = event.target as HTMLInputElement
        this.sinkForm.width = input.value;
    }

    public getApplicationOptions(): Option[] {
        return [
            { value: 'kitchen', label: 'my_displays.application_kitchen' },
            { value: 'bath', label: 'my_displays.application_bath' },
            { value: 'other_spaces', label: 'my_displays.application_other_spaces' },
        ]
    }

    public getFinishes(): Option[] {
        if (this.finishes == null) return []
        return this.finishes.map((finish) => ({
            value: finish.finishCode,
            label: finish.finish.charAt(0).toUpperCase() + finish.finish.slice(1).toLowerCase(),
        }))
    }

    public getFormats(): Option[] {
        if (this.userInfo.market === 'USA') {
            return this.formats.map((format) => ({
                value: format.format,
                label: format.formatUSA,
            }))
        } else {
            return this.formats.map((format) => ({
                value: format.format,
                label: format.format,
            }))
        }
    }

    public getThicknesses(): Option[] {
        return this.thicknesses
            .map((thickness) => ({
                value: thickness.thickness,
                label: thickness.thickness,
            }))
            .sort((a, b) => parseFloat(a.value) - parseFloat(b.value))
    }

    public getAddons(): Option[] {
        return this.addons.map((addon) => ({
            value: addon.addon,
            label: this.getAddonLabel(addon.addon),
        }))
    }

    public getSinkModels(): SelectValue[] {
        return this.sinkModels.map((model) => ({
            id: model.model,
            value: model.model,
            label: model.model,
        }))
    }

    public getSinkBrands(): Option[] {
        return this.sinkBrands.map((brand) => ({
            value: brand.brand,
            label: brand.brand,
        }))
    }

    public getSinkColors(): Option[] {
        return this.colors.map((color) => ({
            value: color.colorCode!,
            label: color.color!,
        }))
    }

    public getSinkFinishes(): Option[] {
        return this.sinkFinishes.map((finish) => ({
            value: finish.finish.finishCode,
            label: finish.finish,
        }))
    }

    public getSinkFormats(): Option[] {
        if (this.userInfo.market === 'USA') {
            return this.sinkFormats.map((format) => ({
                value: format.format,
                label: format.formatUSA,
            }))
        } else {
            return this.sinkFormats.map((format) => ({
                value: format.format,
                label: format.format,
            }))
        }
    }

    /* public getSinkMattresses(): Option[] {
    return this.sinkMattresses.map(mattress => ({
      value: mattress.mattressCode,
      label: mattress.mattress
    }));
  } */

    onApplicationChange(application: string) {
        this.applicationForm.application = application
    }

    onColorChange(color: string) {
        this.applicationForm.color = color
    }

    onDateChanged(value: Date | null) {
        if (value) {
            this.addForm.installationDate = value.toISOString().split('T')[0]
            this.validateInstallationDate()
        } else {
            this.addForm.installationDate = ''
            this.installationDateError = false
        }
    }

    onDateCleared() {
        this.addForm.installationDate = ''
        this.installationDateError = false
    }

    onPreferedArrivalDateChanged(value: Date | null) {
        if (value) {
            this.applicationForm.preferedArrivalDate = value.toISOString().split('T')[0]
            this.applicationForm.preferedArrivalDateDate = value
            this.validatePreferedArrivalDate()
        } else {
            this.applicationForm.preferedArrivalDate = ''
            this.preferedArrivalDateError = false
        }
    }

    private formatDateMMDDYYYY(date: Date): string {
        const month = date.getMonth() + 1
        const day = date.getDate()
        const year = date.getFullYear()
        return `${month}/${day}/${year}`
    }

    public changeApplication() {
        this.applicationTypeSelected = false
        this.applicationColorSelected = false
        this.showerForm.model = ''
        this.sinkForm.model = ''
        this.resetApplicationDetails()
        this.selectedSinkBrandOption = null
        this.selectedSinkColorOption = null
        this.selectedSinkFinishOption = null
        this.selectedSinkFormatOption = null
    }

    public changeColor() {
        this.applicationColorSelected = false
        this.resetApplicationDetails()
        this.selectedSinkBrandOption = null
        this.selectedSinkColorOption = null
        this.selectedSinkFinishOption = null
        this.selectedSinkFormatOption = null
    }

    private resetApplicationDetails(): void {
        this.applicationForm.model = ''
        this.applicationForm.size = ''
        this.applicationForm.finish = ''
        this.applicationForm.format = ''
        this.applicationForm.thickness = ''
        this.applicationForm.addon = ''
        this.applicationForm.texture = ''
        this.applicationForm.mitred = ''
        this.applicationForm.requiredSlabs = ''
        this.sizeDisplayValue = ''
        this.finishes = []
        this.formats = []
        this.thicknesses = []
        this.addons = []
        this.textures = []
        this.finishOptions = []
        this.formatOptions = []
        this.thicknessOptions = []
        this.addonOptions = []
        this.textureOptions = []
        this.selectedFinishOption = null
        this.selectedFormatOption = null
        this.selectedThicknessOption = null
        this.selectedAddonOption = null
        this.selectedTextureOption = null
    }

    public onSizeInput(event: Event): void {
        const input = event.target as HTMLInputElement
        let value = input.value

        // Permitir solo números, punto y coma
        // Eliminar caracteres no válidos excepto números, punto y coma
        value = value.replace(/[^0-9.,]/g, '')

        // Verificar que solo haya un separador decimal (punto o coma, pero no ambos)
        const hasDot = value.includes('.')
        const hasComma = value.includes(',')

        if (hasDot && hasComma) {
            // Si hay ambos, mantener solo el primero que apareció
            const dotIndex = value.indexOf('.')
            const commaIndex = value.indexOf(',')
            if (dotIndex < commaIndex) {
                // Eliminar la coma
                value = value.replace(/,/g, '')
            } else {
                // Eliminar el punto
                value = value.replace(/\./g, '')
            }
        }

        // Permitir solo un separador decimal (sea punto o coma)
        const separatorChar = hasDot ? '.' : ','
        if (hasDot || hasComma) {
            const parts = value.split(separatorChar)
            if (parts.length > 2) {
                value = parts[0] + separatorChar + parts.slice(1).join('')
            }
        }

        // Actualizar el input si se modificó (MANTENER COMA/PUNTO VISIBLE)
        if (input.value !== value) {
            const cursorPosition = input.selectionStart || 0
            input.value = value
            input.setSelectionRange(cursorPosition, cursorPosition)
        }

        // Guardar valor visual (con coma o punto como lo escribió el usuario)
        this.sizeDisplayValue = value

        // Guardar en el modelo normalizando coma a punto (solo internamente)
        this.applicationForm.size = value.replace(',', '.')
    }

    public onSizeBlur(event: Event): void {
        const input = event.target as HTMLInputElement
        let value = input.value

        // Si está vacío, establecer en 0
        if (!value || value === '' || value === '.' || value === ',') {
            value = '0'
            input.value = '0'
            this.sizeDisplayValue = '0'
            this.applicationForm.size = '0'
            return
        }

        // Normalizar: reemplazar coma por punto para procesamiento
        const normalizedValue = value.replace(',', '.')

        // Convertir a número para validación
        const numValue = parseFloat(normalizedValue) || 0

        // Validar máximo de 99
        if (numValue > 99) {
            value = '99'
            input.value = '99'
            this.sizeDisplayValue = '99'
            this.applicationForm.size = '99'
            return
        }

        // Validar mínimo de 0
        if (numValue < 0) {
            value = '0'
            input.value = '0'
            this.sizeDisplayValue = '0'
            this.applicationForm.size = '0'
            return
        }

        // Formatear a 2 decimales si tiene decimales
        if (normalizedValue.includes('.')) {
            const formatted = parseFloat(normalizedValue).toFixed(2)
            // Mantener el separador que usó el usuario (coma o punto)
            const userSeparator = value.includes(',') ? ',' : '.'
            const formattedWithUserSeparator = formatted.replace('.', userSeparator)

            input.value = formattedWithUserSeparator
            this.sizeDisplayValue = formattedWithUserSeparator
            this.applicationForm.size = formatted // Siempre guardar con punto en el modelo
        } else {
            this.sizeDisplayValue = value
            this.applicationForm.size = normalizedValue
        }
    }


    public onRequiredSlabsChange(event: Event): void {
        const input = event.target as HTMLInputElement
        this.applicationForm.requiredSlabs = input.value
    }

    public changeModel() {
        this.showerForm.model = ''
        this.sinkForm.model = ''
    }

    public onSinkModelChange(event: Event): void {
        this.sinkForm.model = event.toString()
        this.applicationModelSelected = true;
        this.loadFullConfigCTS(this.applicationForm.application, event.toString());
    }

    public onShowerModelChange(event: Event): void {
        this.showerForm.model = event.toString()
        this.applicationModelSelected = true;
        this.loadFullConfigCTS(this.applicationForm.application, event.toString());
    }

    // -v-v- CRUD -v-v-
    createDisplay(creditStatus: string, displayToRenew: string): void {
        console.log('Creating display...')

        if (!this.userInfo.salesforceAccountId) {
            console.error('Account ID is required')
            return
        }
        const items = this.addedApplications.map((app) => {
            // Resolver el color desde el catálogo para obtener la marca correcta
            const selectedColor = this.colors.find(
                (c) => c.colorCode === (app.resolvedColorCode || app.color) || c.colorCode === app.color || c.color === app.name
            )
            return {
                displayId: null,
                application: this.normalizeDisplayPayloadApplication(app.application),
                model: app.model,
                brand: selectedColor?.brand || app.brand,
                // Usar el colorCode PCM resuelto (puede ser la variante jumbo) en vez del color base visible.
                color: app.resolvedColorCode || app.color,
                colorName: app.name,
                size: app.size,
                finish: app.finish,
                format: app.format,
                thickness: app.thickness,
                imageUrl: app.thumbImage,
            }
        })

        const newDisplay = {
            displayId: this.displaySFId,
            accountId: this.userInfo.salesforceAccountId,
            environment: this.addForm.application,
            fabricatorId: this.addForm.professional,
            deliveryDate: this.addForm.installationDate,
            creditStatus: creditStatus,
            mainApplication: this.normalizeDisplayPayloadApplication(this.addedApplications[0]?.application || ''),
            mainColor: this.addedApplications[0]?.name || '',
            mainBrand: this.addedApplications[0]?.brand || '',
            mainFinish: this.addedApplications[0]?.finish || '',
            mainThickness: this.addedApplications[0]?.thickness || '',
            mainPhoto: this.addedApplications[0]?.thumbImage || '',
            ownerId: this.userInfo.accountOwnerId || '',
            items: items,
        }

        this.loadingSF = true

        this.api.myDisplays__createDisplay(newDisplay).subscribe({
            next: (response) => {
                console.log('Display created successfully:', response)
                if (this.uploadedSketches.length > 0) {
                    this.uploadDisplayDocument(response.displayId)
                        .then(() => {
                            console.log('Document uploaded successfully')
                            this.loadingSF = false
                            if (displayToRenew) {
                                this.api.myDisplays__requestRenewal(response.displayId, displayToRenew).subscribe({
                                    next: () => {
                                        console.log("Renewal request sent for display " + response.displayId);
                                    },
                                    error: (error) => {
                                       console.error('Error requesting renewal:', error);
                                    }
                                });
                            }
                            this.router.navigate(['/my-displays'])
                        })
                        .catch((error) => {
                            console.error('Error uploading document:', error)
                            this.loadingSF = false
                        })
                } else {
                    this.loadingSF = false
                    this.router.navigate(['/my-displays'])
                }
            },
            error: (error) => {
                console.error('Error creating Display:', error)
                this.loadingSF = false

                // Mostrar modal de error con mensaje traducido
                this.errorModalTitle = this.translate.instant('my_claims.system_error') || 'Error'
                this.errorModalMessage = this.parseDisplayError(error)
                this.isErrorModalVisible = true
            },
        })
    }

    private normalizeDisplayPayloadApplication(application: string): string {
        return application === 'backsplash' ? 'cover' : application
    }

    public async uploadDisplayDocument(displayId: string): Promise<void> {
        try {
            for (const sketch of this.uploadedSketches) {
                const base64File = await this.fileToBase64(sketch.file)

                const body = {
                    displayId: displayId,
                    sketch: {
                        name: sketch.name,
                        type: sketch.type,
                        size: sketch.size,
                        file: base64File,
                    },
                    documentType: sketch.type,
                }

                await this.api.myDisplays__uploadDocument(body).toPromise()
            }
        } catch (error) {
            console.error('Error uploading document:', error)
            throw error
        }
    }

    private fileToBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result as string)
            reader.onerror = (error) => reject(error)
        })
    }
    // -^-^- CRUD -^-^-

    private sortByColorName(colors: any[]): any[] {
        console.log(
            'colors at sort',
            colors.filter((c) => c.discontinuationDate),
        )
        return colors.sort((a, b) => a.color.localeCompare(b.color))
    }

    private sortByColorReleaseDate(colors: any[]): any[] {
        console.log(
          'colors at sort',
          colors.filter((c) => c.discontinuationDate),
        )
        return colors.sort((a, b) => {
            const dateA = a.releaseDate ? new Date(a.releaseDate).getTime() : 0
            const dateB = b.releaseDate ? new Date(b.releaseDate).getTime() : 0
            return dateB - dateA // Descendente: más reciente primero
        })
    }

    public isColorNew(releaseDate: string): boolean {
        if (!releaseDate) {
            return false;
        }
        const release = new Date(releaseDate);
        const now = new Date();
        const twelveMonthsAgo = new Date();
        twelveMonthsAgo.setMonth(now.getMonth() - 12);

        return release >= twelveMonthsAgo && release <= now;
    }

    private normalizeColorValue(value?: string): string {
        return (value || '').trim().toUpperCase()
    }

    // Devuelve el nombre base (sin sufijo JUM/JUMBO) si el valor termina en dicho sufijo, o null.
    private getJumboBaseName(colorValue?: string): string | null {
        const normalized = this.normalizeColorValue(colorValue)
        for (const suffix of ['JUMBO', 'JUM']) {
            if (normalized.length > suffix.length && normalized.endsWith(suffix)) {
                return normalized.slice(0, normalized.length - suffix.length).trim()
            }
        }
        return null
    }

    // Detecta las variantes JUM/JUMBO, las oculta de la lista visible y las relaciona
    // con su color base (mismo nombre sin sufijo) por colorCode.
    private buildJumboColorRelations(colors: KitchenColor[]): { visibleColors: KitchenColor[]; relations: Map<string, string> } {
        const relations = new Map<string, string>()
        const byName = new Map<string, KitchenColor>()
        for (const color of colors) {
            const name = this.normalizeColorValue(color.color)
            if (name && !byName.has(name)) byName.set(name, color)
        }

        const visibleColors: KitchenColor[] = []
        for (const color of colors) {
            const baseName = this.getJumboBaseName(color.color)
            const baseColor = baseName ? byName.get(baseName) : undefined
            if (baseName && baseColor && baseColor !== color) {
                if (baseColor.colorCode && color.colorCode) relations.set(baseColor.colorCode, color.colorCode)
            } else {
                visibleColors.push(color)
            }
        }
        return { visibleColors, relations }
    }

    // Combina dos listas evitando duplicados según la propiedad indicada, etiquetando cada item con el colorCode PCM del que proviene.
    private mergeUniqueBy(base: any[], extra: any[], key: string, baseColorCode?: string, extraColorCode?: string): any[] {
        const tag = (items: any[], colorCode?: string) => (items || []).map((item) => (colorCode ? { ...item, _colorCode: colorCode } : item))
        const result = tag(base, baseColorCode)
        const seen = new Set(result.map((item) => item?.[key]))
        for (const item of tag(extra, extraColorCode)) {
            const value = item?.[key]
            if (!seen.has(value)) {
                seen.add(value)
                result.push(item)
            }
        }
        return result
    }

    // Recupera el colorCode PCM (BRV/BNR) real del item seleccionado, o el color base si no se pudo determinar.
    private resolveColorCodeFor(items: any[], key: string, selectedValue: string | undefined | null): string {
        const match = (items || []).find((item) => item?.[key] === selectedValue)
        return match?._colorCode || this.applicationForm.color
    }

    private loadColors(): void {
        this.loadingColors = true
        this.api.myDisplays__getKitchenColors(this.applicationForm.application).subscribe({
            next: (colors) => {
                const sortedColors = this.sortByColorReleaseDate(colors)
                const { visibleColors, relations } = this.buildJumboColorRelations(sortedColors)
                this.jumboColorRelations = relations
                this.colors = visibleColors
                this.setupFiltersForColors()
                this.filteredColors = [...this.colors]
                this.clearFilters()
                this.loadingColors = false
                this.cdr.detectChanges() // Forzar detección de cambios
            },
            error: (error) => {
                console.error('Error loading colors:', error)
                this.loadingColors = false
                this.colors = []
                this.filteredColors = []
                this.jumboColorRelations.clear()
                this.cdr.detectChanges()
            },
        })
    }

    private loadFinishes(): void {
        this.loadingFinishes = true
        const relatedColor = this.jumboColorRelations.get(this.applicationForm.color)
        const finishes$ = relatedColor
            ? forkJoin([
                  this.api.myDisplays__getFinishesByColor(this.applicationForm.application, this.applicationForm.color, this.applicationForm.brand),
                  this.api.myDisplays__getFinishesByColor(this.applicationForm.application, relatedColor, this.applicationForm.brand),
              ]).pipe(map(([base, jumbo]) => this.mergeUniqueBy(base, jumbo, 'finishCode', this.applicationForm.color, relatedColor)))
            : this.api
                  .myDisplays__getFinishesByColor(this.applicationForm.application, this.applicationForm.color, this.applicationForm.brand)
                  .pipe(map((base) => this.mergeUniqueBy(base, [], 'finishCode', this.applicationForm.color)))
        finishes$.subscribe({
            next: (finishes) => {
                this.finishes = finishes
                this.finishOptions = (this.finishes || []).map((f) => ({
                    value: f.finishCode,
                    label: this.translate.instant('finishes.' + f.finishCode),
                    id: f.finishCode,
                }))
                this.selectedFinishOption = this.toSelectValue(this.finishOptions, this.applicationForm.finish)
                this.loadingFinishes = false
            },
            error: (error) => {
                console.error('Error loading finishes:', error)
                this.loadingFinishes = false
                this.finishes = []
                this.finishOptions = []
                this.selectedFinishOption = null
            },
        })
    }

    private loadFormats(): void {
        this.loadingFormats = true
        const relatedColor = this.jumboColorRelations.get(this.applicationForm.color)
        const formats$ = relatedColor
            ? forkJoin([
                  this.api.myDisplays__getFormatsByColorAndFinish(this.applicationForm.application, this.applicationForm.color, this.applicationForm.brand, this.applicationForm.finish),
                  this.api.myDisplays__getFormatsByColorAndFinish(this.applicationForm.application, relatedColor, this.applicationForm.brand, this.applicationForm.finish),
              ]).pipe(map(([base, jumbo]) => this.mergeUniqueBy(base, jumbo, 'format', this.applicationForm.color, relatedColor)))
            : this.api
                  .myDisplays__getFormatsByColorAndFinish(this.applicationForm.application, this.applicationForm.color, this.applicationForm.brand, this.applicationForm.finish)
                  .pipe(map((base) => this.mergeUniqueBy(base, [], 'format', this.applicationForm.color)))
        formats$.subscribe({
                next: (formats) => {
                    this.formats = formats
                    this.formatOptions = this.formats.map((format) => ({ value: format.format, label: this.getFormatLabel(format), id: format.format }))
                    this.selectedFormatOption = this.toSelectValue(this.formatOptions, this.applicationForm.format)
                    this.loadingFormats = false
                },
                error: (error) => {
                    console.error('Error loading formats:', error)
                    this.loadingFormats = false
                    this.formats = []
                    this.formatOptions = []
                    this.selectedFormatOption = null
                },
            })
    }

    private loadThicknesses(): void {
        this.loadingThicknesses = true
        const relatedColor = this.jumboColorRelations.get(this.applicationForm.color)
        const thicknesses$ = relatedColor
            ? forkJoin([
                  this.api.myDisplays__getThicknessesByColorFinishAndFormat(
                      this.applicationForm.application,
                      this.applicationForm.color,
                      this.applicationForm.brand,
                      this.applicationForm.finish,
                      this.applicationForm.format,
                  ),
                  this.api.myDisplays__getThicknessesByColorFinishAndFormat(
                      this.applicationForm.application,
                      relatedColor,
                      this.applicationForm.brand,
                      this.applicationForm.finish,
                      this.applicationForm.format,
                  ),
              ]).pipe(map(([base, jumbo]) => this.mergeUniqueBy(base, jumbo, 'thickness', this.applicationForm.color, relatedColor)))
            : this.api
                  .myDisplays__getThicknessesByColorFinishAndFormat(
                      this.applicationForm.application,
                      this.applicationForm.color,
                      this.applicationForm.brand,
                      this.applicationForm.finish,
                      this.applicationForm.format,
                  )
                  .pipe(map((base) => this.mergeUniqueBy(base, [], 'thickness', this.applicationForm.color)))
        thicknesses$.subscribe({
                next: (thicknesses) => {
                    this.thicknesses = thicknesses
                    this.thicknessOptions = (this.thicknesses || [])
                        .map((t) => ({ value: t.thickness, label: t.thickness, id: t.thickness }))
                        .sort((a, b) => parseFloat(a.value) - parseFloat(b.value))
                    this.selectedThicknessOption = this.toSelectValue(this.thicknessOptions, this.applicationForm.thickness)
                    this.loadingThicknesses = false
                },
                error: (error) => {
                    console.error('Error loading thicknesses:', error)
                    this.loadingThicknesses = false
                    this.thicknesses = []
                    this.thicknessOptions = []
                    this.selectedThicknessOption = null
                },
            })
    }

    private loadAddons(): void {
        this.loadingAddons = true
        this.api
            .myDisplays__getAddonsByColorFinishAndFormatAndThicknesses(
                this.applicationForm.application,
                this.applicationForm.color,
                this.applicationForm.brand,
                this.applicationForm.finish,
                this.applicationForm.format,
                this.applicationForm.thickness,
            )
            .subscribe({
                next: (addons) => {
                    this.addons = addons
                    this.addonOptions = this.addNAOption((this.addons).map((a) => ({ value: a.addon, label: this.getAddonLabel(a.addon), id: a.addon })))
                    this.selectedAddonOption = this.toSelectValue(this.addonOptions, this.applicationForm.addon)
                    this.loadingAddons = false
                },
                error: (error) => {
                    console.error('Error loading addons:', error)
                    this.loadingAddons = false
                    this.addons = []
                    this.addonOptions = []
                    this.selectedAddonOption = null
                },
            })
    }

    private loadTextures(): void {
      this.loadingTextures = true
      this.api.myDisplays__getTexturesByColorFinishAndFormatAndThicknesses(
        this.applicationForm.application,
        this.applicationForm.color,
        this.applicationForm.brand,
        this.applicationForm.finish,
        this.applicationForm.format,
        this.applicationForm.thickness,
      )
      .subscribe({
        next: (textures) => {
          this.textures = textures
          this.textureOptions = (this.textures || []).map((a) => ({ value: a.textureId, label: a.textureId, id: a.textureId }))
          this.selectedTextureOption = this.toSelectValue(this.textureOptions, this.applicationForm.texture)
          this.loadingTextures = false
        },
        error: (error) => {
          console.error('Error loading textures:', error)
          this.loadingTextures = false
          this.textures = []
          this.textureOptions = []
          this.selectedTextureOption = null
        },
      })
    }

    private loadSinkModels(): void {
        this.loadingSinkModels = true
        this.api.myDisplays__getSinkModels(this.applicationForm.application).subscribe({
            next: (sinkModels) => {
                this.sinkModels = sinkModels
                this.sinkOptions = this.getSinkModels()
                this.loadingSinkModels = false
            },
            error: (error) => {
                console.error('Error loading sink models:', error)
                this.loadingSinkModels = false
                this.sinkModels = []
            },
        })
    }

    private loadSinkSubmodels() {
        return new Promise<void>((resolve) => {
            this.api.myDisplays__getSinkSubModels(this.sinkModels[0].model).subscribe({
                next: (subModels) => {
                    this.sinkSubmodels = subModels
                    this.loadingSinkSubmodels = false
                    resolve()
                },
                error: (error) => {
                    console.error('Error loading sink submodels:', error)
                    this.loadingSinkSubmodels = false
                    this.sinkSubmodels = []
                    resolve()
                },
            })
        })
    }

    /*private loadSinkBasin(): void {
      return null;
    }*/

    private loadSinkBrands(): void {
        this.api.myDisplays__getSinkBrands(this.addForm.application, this.sinkModels[0].model, this.sinkSubmodels[0]?.id).subscribe({
            next: (brands) => {
                this.sinkBrands = brands
                this.sinkBrandOptions = (this.sinkBrands || []).map((b) => ({ value: b.brand, label: b.brand, id: b.brand }))
                this.selectedSinkBrandOption = this.toSelectValue(this.sinkBrandOptions, this.sinkForm.brand)
                this.loadingSinkBrands = false
            },
            error: (error) => {
                console.error('Error loading sink brands:', error)
                this.loadingSinkBrands = false
                this.sinkBrands = []
                this.sinkBrandOptions = []
                this.selectedSinkBrandOption = null
            },
        })
    }

    private loadSinkColors(): void {
        this.api.myDisplays__getSinkColors(this.addForm.application, this.applicationForm.application, this.sinkModels[0].model, this.sinkSubmodels[0]?.id).subscribe({
            next: (colors) => {
                this.colors = colors
                this.sinkColorOptions = (this.colors || []).map((color) => ({ value: color.colorCode!, label: color.color!, id: color.colorCode!, image: color.pictures?.thumb }))
                this.selectedSinkColorOption = this.toSelectValue(this.sinkColorOptions, this.sinkForm.color)
                this.setupFiltersForColors()
                this.filteredColors = []
                this.clearFilters()
                this.loadingColors = false
                this.cdr.detectChanges() // Forzar detección de cambios
            },
            error: (error) => {
                console.error('Error loading colors:', error)
                this.loadingColors = false
                this.colors = []
                this.sinkColorOptions = []
                this.selectedSinkColorOption = null
                this.filteredColors = []
                this.cdr.detectChanges()
            },
        })
    }

    private setupFiltersForColors() {
        const brands = <string[]>[...this.colors.map((color) => color.brand?.toLowerCase()).filter((brand) => !!brand)]
        const brandsSet = [...new Set(brands)]
        const tones = <string[]>[...this.colors.map((color) => color.tone?.toLowerCase()).filter((tone) => !!tone)]
        const tonesSet = [...new Set(tones)]

        this.brandOptions = brandsSet.map((brand) => {
            let label: string = this.translate.instant(`brands.${brand}`)
            if (label.includes('brands.')) label = brand.slice(0, 1).toUpperCase() + brand.slice(1)
            return {
                id: brand,
                value: brand,
                label: label,
            }
        })
        this.toneOptions = tonesSet.map((tone) => {
            let label: string = this.translate.instant(`tones.${tone}`)
            if (label.includes('tones.')) label = tone.slice(0, 1).toUpperCase() + tone.slice(1)
            return {
                id: tone,
                value: tone,
                label: label,
            }
        })
        let otherLabel = this.translate.instant('brands.other')
        if (otherLabel.includes('brands.')) otherLabel = 'Other'
        this.toneOptions.push({
            id: 'other',
            value: 'other',
            label: otherLabel,
        })
    }

    private loadSinkFinishes(): void {
        this.api
            .myDisplays__getSinkFinishes(this.addForm.application, this.applicationForm.application, this.sinkForm.brand, this.sinkForm.color, this.sinkModels[0].model, this.sinkSubmodels[0]?.id)
            .subscribe({
                next: (finishes) => {
                    this.sinkFinishes = finishes
                    this.sinkFinishOptions = (this.sinkFinishes || []).map((f) => ({ value: f.finishCode, label: this.translate.instant('finishes.' + f.finishCode), id: f.finishCode }))
                    this.selectedSinkFinishOption = this.toSelectValue(this.sinkFinishOptions, this.sinkForm.finish)
                    this.loadingFinishes = false
                    this.cdr.detectChanges() // Forzar detección de cambios
                },
                error: (error) => {
                    console.error('Error loading finishes:', error)
                    this.loadingFinishes = false
                    this.sinkFinishes = []
                    this.sinkFinishOptions = []
                    this.selectedSinkFinishOption = null
                    this.cdr.detectChanges()
                },
            })
    }

    private loadSinkFormats(): void {
        this.api
            .myDisplays__getSinkFormats(
                this.addForm.application,
                this.applicationForm.application,
                this.sinkForm.brand,
                this.sinkForm.color,
                this.sinkForm.finish,
                this.sinkModels[0].model,
                this.sinkSubmodels[0]?.id
            )
            .subscribe({
                next: (formats) => {
                    this.sinkFormats = formats
                    this.sinkFormatOptions = this.sinkFormats.map((format) => ({ value: format.format, label: this.getFormatLabel(format), id: format.format }))
                    this.selectedSinkFormatOption = this.toSelectValue(this.sinkFormatOptions, this.sinkForm.format)
                    this.loadingFormats = false
                    this.cdr.detectChanges() // Forzar detección de cambios
                },
                error: (error) => {
                    console.error('Error loading formats:', error)
                    this.loadingFormats = false
                    this.sinkFormats = []
                    this.sinkFormatOptions = []
                    this.selectedSinkFormatOption = null
                    this.cdr.detectChanges()
                },
            })
    }

    private loadModelsCTS(): void {
        this.loadingSinkModels = true
        if (this.applicationForm.application === 'bath_sink') {
          this.api.myDisplays__getModelsCTS('bath_sink').subscribe({
            next: (models) => {
              this.sinkModels = models
              this.loadingSinkModels = false
            },
            error: (error) => {
              console.error('Error loading models:', error)
              this.loadingSinkModels = false
              this.sinkModels = []
            },
          })
        } else if (this.applicationForm.application === 'bath_showertray') {
          this.api.myDisplays__getModelsCTS('bath_showertray').subscribe({
            next: (models) => {
              this.showerModels = models
              this.loadingShowerModels = false
            },
            error: (error) => {
              console.error('Error loading models:', error)
              this.loadingShowerModels = false
              this.showerModels = []
            },
          })
        }
    }

    private loadFullConfigCTS(type: string, model: string): void {
        this.api.myDisplays__getFullConfigCTS(type, model).subscribe({
            next: (fullconfig: any) => {
                console.log('Full config: ', fullconfig)
                this.fullConfigCTS = fullconfig;
                this.sinkBrandOptions = Object.keys(fullconfig.brands || {}).map(brand => ({
                    id: brand,
                    value: brand,
                    label: brand
                }));
                /* this.showerModels = fullconfig
                this.loadingShowerModels = false */
            },
            error: (error) => {
                console.error('Error loading models:', error)
                /* this.loadingShowerModels = false
                this.showerModels = [] */
            },
        })
    }

    // Convert mm format to inches (e.g., "306X141" -> "12.05\"X5.55\"")
    private convertFormatToUSA(format: string): string {
        const parts = format.split('X')
        if (parts.length === 2) {
            const width = (parseInt(parts[0]) / 25.4).toFixed(2)
            const height = (parseInt(parts[1]) / 25.4).toFixed(2)
            return `${width}"X${height}"`
        }
        return format
    }

    // Get the correct format label based on market and available data
    private getFormatLabel(format: any): string {
        // If formatUSA exists, use it for USA market
        if (format.formatUSA) {
            return this.userInfo.market === 'USA' ? format.formatUSA : format.format
        }
        // If no formatUSA and user is USA, convert mm to inches
        if (this.userInfo.market === 'USA') {
            return this.convertFormatToUSA(format.format)
        }
        // Default to format
        return format.format
    }

    // Helper to adapt string model values to SelectValue expected by app-select
    public toSelectValue(options: { value: string; label: string }[] | SelectValue[], value: string | null | undefined): SelectValue | null {
        if (!value) return null
        const opt: any = (options || []).find((o: any) => o && typeof o.value !== 'undefined' && o.value === value)
        return opt ? { value: opt.value, label: opt.label, id: opt.id ?? opt.value } : null
    }

    // Map Option[] to SelectValue[]
    private mapToSelectValues(options: { value: string; label: string }[] = []): SelectValue[] {
        return (options || []).map((o) => ({ value: o.value, label: o.label, id: o.value }))
    }

    colorSearchValue: string = ''
    filteredColors: KitchenColor[] = []

    brandOptions: SelectValue[] = []
    selectedBrand: SelectValue | null = null

    toneOptions: SelectValue[] = []
    selectedTone: SelectValue | null = null

    searchColors() {
        const foundColors = this.colors.filter((color) => {
            if (this.colorSearchValue.length > 0) {
                return color.color!.toLowerCase().includes(this.colorSearchValue.toLowerCase())
            }

            return (
                (!this.selectedBrand || this.brandEquals(color.brand!, this.selectedBrand.value)) && (!this.selectedTone || this.toneEquals(color.tone!, this.selectedTone.value))
            )
        })

        this.filteredColors = foundColors

        console.log(foundColors)
    }

    brandEquals(colorBrand: string, selectedBrand: string) {
        return colorBrand.toLowerCase() === selectedBrand.toLowerCase()
    }

    toneEquals(colorTone: string, selectedTone: string) {
        if (selectedTone === 'other') return colorTone === 'other' || !colorTone
        return colorTone.toLowerCase() === selectedTone.toLowerCase()
    }

    clearFilters() {
        this.filteredColors = [...this.colors]
        this.colorSearchValue = ''
        this.selectedBrand = null
        this.selectedTone = null
    }

    getLegalNoticeLink() {
      this.api.myDisplays__getLegalNoticeLink().subscribe({
        next: (response: any) => {
          this.legalNoticeLink = response.link
          this.cdr.detectChanges()
        },
        error: (error) => {
          console.error('Error loading legal notice link:', error)
        },
      })
    }

    public closeErrorModal(): void {
        this.isErrorModalVisible = false
        this.errorModalTitle = ''
        this.errorModalMessage = ''
    }


    private readonly SF_ERROR_MAPPINGS: { pattern: RegExp; translationKey: string }[] = [
        { pattern: /more than \d+ Slabs \/ Units.*annual limit/i, translationKey: 'my_displays.error_slabs_limit_exceeded' },
        { pattern: /not possible to enter more Slabs/i, translationKey: 'my_displays.error_annual_limit_exceeded' },
    ]

    /**
     * Parses a Salesforce error response and returns a user-friendly translated message.
     * @param errorResponse The raw error response from the API
     * @returns A translated error message
     */
    private parseDisplayError(errorResponse: any): string {
        try {
            const rawError = errorResponse?.error?.error || errorResponse?.error || '';

            let message = rawError;

            const salesforcePrefix = /^SALESFORCE:\s*Error\s*->\s*/i;
            if (salesforcePrefix.test(message)) {
                message = message.replace(salesforcePrefix, '');
            }

            try {
                const jsonStr = message.replace(/'/g, '"');
                const parsed = JSON.parse(jsonStr);

                if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].message) {
                    message = parsed[0].message;
                }
            } catch {
                const messageMatch = message.match(/['"]message['"]\s*:\s*['"]([^'"]+)['"]/);
                if (messageMatch && messageMatch[1]) {
                    message = messageMatch[1];
                }
            }

            for (const mapping of this.SF_ERROR_MAPPINGS) {
                if (mapping.pattern.test(message)) {
                    return this.translate.instant(mapping.translationKey);
                }
            }

            return this.translate.instant('my_displays.error_generic_display_creation');
        } catch {
            return this.translate.instant('my_displays.error_generic_display_creation');
        }
    }

    private addNAOption(options: SelectValue[]): SelectValue[] {
      if (!options || options.length === 0 || (options.length === 1 && options[0].value === '')) {
        return [{ value: 'N/A', label: 'N/A', id: 'N/A' }];
      }
      return options;
    }

        private getAddonLabel(addon: string): string {
                const translationKey = 'finishes.' + addon
                const translation = this.translate.instant(translationKey)
                return translation && translation !== translationKey ? translation : addon
        }

    getFormatDate() {
        return this.userInfo?.market === 'USA' ? 'MM/DD/YYYY' : 'DD/MM/YYYY'
    }

    ngOnDestroy(): void {
        if (this.previousPlatform) {
            this.platformService.setContextualPlatform(this.previousPlatform)
        }
    }
}
